import React, { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";
import { api } from "../../context/AuthContext";

const RANGES = [7, 30, 90];
const SERIES = [
  { key: "seafarer", label: "Seafarers", color: "#002855" },
  { key: "company", label: "Companies", color: "#FF4500" },
  { key: "institute", label: "Institutes", color: "#16a34a" },
  { key: "pending", label: "Role not chosen", color: "#94a3b8" },
];

const fmtDay = (d) => new Date(d + "T00:00:00").toLocaleDateString(undefined, { day: "numeric", month: "short" });

export const GrowthChart = ({ refreshKey }) => {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/admin/growth?days=${days}`).then((r) => setData(r.data)).catch(() => {});
  }, [days, refreshKey]);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5" data-testid="admin-growth">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="font-heading text-base font-bold text-slate-900">Daily sign-ups</h2>
          <p className="text-xs text-slate-500" data-testid="admin-growth-total">{data ? `${data.total} new member${data.total === 1 ? "" : "s"} in the last ${days} days` : "Loading…"}</p>
        </div>
        <div className="flex gap-1 rounded-full bg-slate-100 p-1">
          {RANGES.map((r) => (
            <button key={r} onClick={() => setDays(r)} data-testid={`admin-growth-range-${r}`}
              className={`rounded-full px-3.5 py-1.5 text-xs font-bold transition-colors ${days === r ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-900"}`}>
              {r} days
            </button>
          ))}
        </div>
      </div>
      <div className="mt-4 h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data?.series || []} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f1f5f9" />
            <XAxis dataKey="date" tickFormatter={fmtDay} tick={{ fontSize: 11, fill: "#94a3b8" }} tickLine={false} axisLine={false} minTickGap={16} />
            <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#94a3b8" }} tickLine={false} axisLine={false} />
            <Tooltip labelFormatter={fmtDay} cursor={{ fill: "#f8fafc" }} contentStyle={{ borderRadius: 12, border: "1px solid #e2e8f0", fontSize: 12 }} />
            <Legend iconType="circle" wrapperStyle={{ fontSize: 12 }} />
            {SERIES.map((s, i) => (
              <Bar key={s.key} dataKey={s.key} name={s.label} stackId="a" fill={s.color} radius={i === SERIES.length - 1 ? [4, 4, 0, 0] : 0} maxBarSize={28} />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default GrowthChart;
